import React from 'react';

/**
 * Extending / Anchor tabs (AssignmentCollaborationPanel tab style).
 * Optional children render inside the active kind container (name, about, period, etc.).
 */
const ExtendingIcon = () => (
  <svg
    className="groups-kind-tab-icon"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const AnchorIcon = () => (
  <svg
    className="groups-kind-tab-icon"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    <circle cx="12" cy="5" r="3" />
    <line x1="12" y1="8" x2="12" y2="21" />
    <path d="M5 12H2a10 10 0 0 0 20 0h-3" />
  </svg>
);

const GroupsMembershipKindField = ({
  value = 'extending',
  onChange,
  disabled = false,
  children = null,
  trailing = null
}) => (
  <div className="groups-kind-tabs-wrap">
    <div className="groups-kind-tabs-bar">
      <div className="groups-kind-tabs" role="tablist" aria-label="Membership kind">
        <button
          type="button"
          role="tab"
          aria-selected={value === 'extending'}
          className={`groups-kind-tab groups-kind-tab--extending${
            value === 'extending' ? ' is-active' : ''
          }`}
          onClick={() => onChange?.('extending')}
          disabled={disabled}
        >
          <ExtendingIcon />
          <span>Extending</span>
        </button>
        <button
          type="button"
          role="tab"
          aria-selected={value === 'anchor'}
          className={`groups-kind-tab groups-kind-tab--anchor${value === 'anchor' ? ' is-active' : ''}`}
          onClick={() => onChange?.('anchor')}
          disabled={disabled}
        >
          <AnchorIcon />
          <span>Anchor</span>
        </button>
      </div>
      {trailing ? <div className="groups-kind-tabs-trailing">{trailing}</div> : null}
    </div>
    <div className={`groups-kind-panel groups-kind-panel--${value}`} role="tabpanel">
      {value === 'anchor' ? (
        <p className="groups-kind-hint">
          Members act <em>as</em> this role — a sign-in identity in the role switcher (e.g. Students,
          Teachers, Coaches). Use only for a primary identity, not clubs or containers.
        </p>
      ) : (
        <p className="groups-kind-hint">
          Members just belong — never a sign-in identity. Shows on their profile via an anchor role.
          Right for clubs, rosters, and containers like Sports.
        </p>
      )}
      {children ? <div className="groups-kind-panel-body">{children}</div> : null}
    </div>
  </div>
);

export default GroupsMembershipKindField;
